import api from './client'
import type { AiUsageLogDetail, AiUsageLogFilters, PaginatedAiUsageLogs } from '@/types/models'

export const aiUsageApi = {
  async listAiUsageLogs(filters: AiUsageLogFilters = {}): Promise<PaginatedAiUsageLogs> {
    const params: Record<string, string | number> = {}
    if (filters.operation) params['filter[operation]'] = filters.operation
    if (filters.model) params['filter[model]'] = filters.model
    if (filters.created_after) params['filter[created_after]'] = filters.created_after
    if (filters.created_before) params['filter[created_before]'] = filters.created_before
    if (filters.causer_id) params['filter[causer_id]'] = filters.causer_id
    if (filters.sort) params.sort = filters.sort
    if (filters.page) params.page = filters.page
    if (filters.per_page) params.per_page = filters.per_page

    const { data } = await api.get<PaginatedAiUsageLogs>('/ai-usage-logs', { params })
    return data
  },

  // Kept as the full envelope (not unwrap()'d) — the detail page's waterfall
  // needs the sibling `run_calls` array riding alongside `data`, not just the
  // requested row.
  async getAiUsageLog(id: string): Promise<AiUsageLogDetail> {
    const { data } = await api.get<AiUsageLogDetail>(`/ai-usage-logs/${id}`)
    return data
  },
}
